var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 129,
    viewBox: "0 0 158 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 30.5216C158 66.0666 100.033 129 64.4423 129C28.8518 129 0 100.185 0 64.6401C0 29.0951 28.8518 0.280148 64.4423 0.280148C100.033 0.280148 158 -5.02345 158 30.5216Z",
    fill: "url(#paint0_linear_311_3442)",
    fillOpacity: 0.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 88.4417C92.6001 97.1856 59.1549 97.1856 48.6623 88.4417C37.951 79.6979 39.044 42.3179 48.6623 32.4811C58.2805 22.6443 93.6931 22.6443 103.311 32.4811C112.93 42.3179 114.023 79.698 103.311 88.4417Z",
    fill: "#14C364"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2057 73.1403C66.5875 80.7912 55.8762 84.7259 45.8209 84.9444C38.3885 72.2659 39.9188 41.4439 48.6626 32.4815C56.5321 24.3934 81.2334 22.8632 95.4422 27.8909C98.9397 42.3183 91.7261 60.6802 76.2057 73.1403Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9592 79.4791C69.429 79.4791 67.8989 78.8233 67.0245 77.5117L54.7832 61.7728C53.0344 59.5869 53.4716 56.5266 55.6576 54.7778C57.8435 53.029 60.9038 53.4663 62.6526 55.6522L70.9592 66.3634L89.3213 42.5365C91.0701 40.3505 94.1304 39.9133 96.3164 41.6621C98.5023 43.4109 98.9396 46.4712 97.1908 48.6571L74.8939 77.5117C73.801 78.6047 72.4894 79.4791 70.9592 79.4791Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_3442",
    x1: 79,
    y1: 0,
    x2: 79,
    y2: 129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.9662fcbae419041fd0c0325a06bc00ba.svg";
export { ForwardRef as ReactComponent };